import { TraceProfile } from '@trace/types';
import React, { createContext, FunctionComponent } from 'react';
import { Redirect } from 'react-router';
import { AuthenticationState } from './useAuthentication';
import useAuthenticationTrace from './useAuthenticationTrace';
import PageLoad from '../Page/PageLoad';

export const AuthContextTrace = createContext<AuthenticationState<TraceProfile>>({
  data: {
    accountId: '',
    appId: '',
    ownerSlug: '',
    userSlug: '',
    defaultBranch: '',
    plan: '',
    appTitle: '',
  },
  isAuthenticating: true,
  isTokenValid: false,
  token: '',
});

const AuthenticateTrace: FunctionComponent = (props) => {
  const auth = useAuthenticationTrace();

  if (auth.isAuthenticating) {
    return <PageLoad />;
  }

  if (!auth.isTokenValid) {
    return <Redirect to="/" />;
  }

  return <AuthContextTrace.Provider {...props} value={auth} />;
};

export default AuthenticateTrace;
